import type { TTipoDeDocumentoEnum } from '@/features/proposta/interfaces/proposta.enums'

export const tipoDocumentoMap: Record<TTipoDeDocumentoEnum, string> = {
  CNH: 'CNH',
  CPF: 'CPF',
  CartaoCNPJ: 'Cartão CNPJ',
  CertidaoDeCasamento: 'Certidão de Casamento',
  CertidaoDeNascimento: 'Certidão de Nascimento',
  CertidaoJuntaComercial: 'Certidão Junta Comercial',
  Checklist: 'Checklist',
  ComprovanteDeEnderecoDaEmpresa: 'Comprovante de Endereço da Empresa',
  ComprovanteDePagamento: 'Comprovante de Pagamento',
  ComprovanteDeResidencia: 'Comprovante de Residência',
  ContratoSocial: 'Contrato Social',
  OutroDocumento: 'Outro Documento',
  Procuracao: 'Procuração',
  RG: 'RG',
  UltimaAlteracao: 'Última Alteração',
}
